import { render, staticRenderFns } from "./SystemShareView.vue?vue&type=template&id=77a9a079&"
import script from "./SystemShareView.vue?vue&type=script&lang=js&"
export * from "./SystemShareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports